import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/service/`,
    detail: (id) => `${BASE_URL}/api/v1/service/${id}/`,
};

export const serviceLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const serviceDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const serviceUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const serviceDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
